import { useAppState } from "../context/appStateContext"
import useQueryParams from "./useQueryParams"

const useHasPro = (): boolean => {
  const { state } = useAppState()
  const queryParams = useQueryParams()

  return queryParams.hasPro || state.productData?.hasPro === true
}

export default useHasPro
